import React from 'react';
import Icon from '../../../components/AppIcon';

const StudyGoalCard = ({ goal, current, target, dueDate, priority }) => {
  const percentage = target > 0 ? Math.round((current / target) * 100) : 0;
  const isOverdue = new Date(dueDate) < new Date();
  
  const getPriorityConfig = (priorityLevel) => {
    switch (priorityLevel) {
      case 'high':
        return { color: 'text-error', bg: 'bg-error/10', icon: 'AlertCircle' };
      case 'medium':
        return { color: 'text-warning', bg: 'bg-warning/10', icon: 'Clock' };
      case 'low':
        return { color: 'text-primary', bg: 'bg-primary/10', icon: 'Info' };
      default:
        return { color: 'text-muted-foreground', bg: 'bg-muted', icon: 'Circle' };
    }
  };

  const priorityConfig = getPriorityConfig(priority);

  return (
    <div className="bg-card rounded-lg p-4 border border-border transition-smooth hover:shadow-elevation-1">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h5 className="text-sm md:text-base font-medium text-foreground mb-1 line-clamp-2">
            {goal}
          </h5>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="data-text whitespace-nowrap">{current} / {target}</span>
            <span className="w-1 h-1 rounded-full bg-muted-foreground" />
            <span className={isOverdue ? 'text-error' : ''}>
              Due {dueDate}
            </span>
          </div>
        </div>
        <div className={`px-2 py-1 rounded-md ${priorityConfig?.bg} flex-shrink-0 ml-2`}>
          <Icon name={priorityConfig?.icon} size={14} className={priorityConfig?.color} />
        </div>
      </div>
      <div className="space-y-2">
        <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ${
              percentage >= 100 ? 'bg-success' : 'bg-primary'
            }`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">{percentage}% complete</span>
          {percentage >= 100 && (
            <span className="flex items-center gap-1 text-success">
              <Icon name="CheckCircle2" size={12} />
              <span>Completed</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudyGoalCard;